/* eslint-disable prettier/prettier */
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html {
    &.scroll-hide {
      overflow: hidden;
    }
  }

  body {
    -webkit-font-smoothing: antialiased;
    background: ${props => (props.backgroundColor ? props.backgroundColor : '#222222')};
  }

  body, input, button {
    font-family: 'Montserrat', sans-serif;
  }

  button {
    cursor: pointer;
  }

  ul {
    list-style: none;
  }
  li {
    list-style: none;
  }
  a {
    text-decoration: none;
  }
`;
